import React, { CSSProperties, useState, useEffect } from 'react';
import Select, { MultiValue } from 'react-select';
import { InputActionMeta } from 'react-select';
import '../SearchableDropdown/SearchableDropdown.scss';
import { toString, set } from 'lodash';

interface OptionType {
    label: string;
    value: string;
}

interface MultiSelectDropdownProps {
    //lofas: (Lofas | null)[];
    dropdownOptions: OptionType[];
    onInputChange?: (inputValue: string, actionMeta: InputActionMeta) => string;
    onChange?: (value: OptionType) => void;
    value?:OptionType | null;
    label: string;
    error?: boolean;
    helperText?: string;
    disabled?: boolean;
}

export const MultiSelectDropdown = ({
    dropdownOptions,
    onInputChange,
    onChange,
    value,
    label,
    error,
    helperText,
    disabled,
}: MultiSelectDropdownProps): React.ReactElement => {
    const [single, setSingle] = useState<OptionType>(value? value : {label: '', value:''});

    useEffect(() => {
        setSingle(value? value : {label: '', value:''});
    }, [value]);

    // const [selectedOption] = useState('none');

    // const handleTypeSelect: (e: any) => void {
    //     setSelectedOption(e.value);
    // };
    // const [selectedValue, setSelectedValue] = useState<string | number | null | undefined>(value);
    // const [state, setState] = React.useState({ single: '' });
    // useEffect(() => {
    //     setSelectedValue(value ? value : '');
    // }, [value]);

    // const handleChangeSingle = (value: OptionType): void => {
    //     setSingle(value);
    //     if (onChange) onChange(value);
    // };

     const handleChangeSingle = (newvalue: MultiValue<OptionType>): void => {
        
        const value = newvalue as unknown as OptionType;
        setSingle(value);
        if (onChange) onChange(value);
    };

    const handleInputChange = (inputValue: string, actionMeta: InputActionMeta): string => {
        if (onInputChange) onInputChange(inputValue, actionMeta);
        return inputValue;
    };
    const selectStyles = {
        menu: (base) => ({
            ...base,
           
                fontSize: 10,
            
        }),
    };

    const suggestions: OptionType[] =
        dropdownOptions &&
        dropdownOptions.map(it => ({
            value: it && it.value ? it.value : '',
            label: it && it.label ? it.label : '',
        }));

    return (
        <div className="SearchableDropdown">
            <label className={`Searchable-Dropdown-Label`}>{label}</label>
            <div>
                <Select
                    isMulti={true}
                    styles={selectStyles}
                    // TextFieldProps={{
                    //     label: label,
                    //     error: error,
                    //     helperText: helperText,
                    //     InputLabelProps: {
                    //         htmlFor: 'react-select-single',
                    //         shrink: true,
                    //     },
                    // }}
                    placeholder=""
                    options={suggestions}
                    key={`my_unique_select_key__${JSON.stringify(single)}`}
                    value={single}
                    onChange={handleChangeSingle}
                    onInputChange={handleInputChange}
                    isDisabled={disabled}
                />
            </div>
        </div>
    );
};

export default MultiSelectDropdownProps;
